import { Home, Ayuda, Shipment, Alarms } from "../pages";
import PreRegistration from "../pages/PreRegistration/PreRegistration";
import Recipients from "../pages/Recipients/Recipients";
import Senders from "../pages/Senders/Senders";
import MaterialRequest from "../pages/MaterialRequest/MaterialRequest";
import RequestHistory from "../pages/RequestHistory/RequestHistory";

const pathRoutes = [
  {
    path: "/",
    component: Home,
    label: "router_routes.home",
    public: true,
  },
  // {
  //   path: "/envio",
  //   component: Shipment,
  //   label: "",
  //   public: false,
  // },
  {
    path: "/alarmas",
    component: Alarms,
    label: "Alarmas",
    public: false,
  },
  {
    path: "/remitentes",
    component: Senders,
    label: "Remitentes",
    public: false,
    parent: "/pre-registro",
  },
  {
    path: "/destinatarios",
    component: Recipients,
    label: "Destinatarios",
    public: false,
    parent: "/pre-registro",
  },
  {
    path: "/pre-registro",
    component: PreRegistration,
    label: "Pre-registro",
    public: false,
    isParent: true,
  },
  {
    path: "/material",
    component: MaterialRequest,
    label: "Petición Material",
    public: false,
  },
  {
    path: "/historial",
    component: RequestHistory,
    label: "Historial",
    public: false,
  },
  {
    path: "/ayuda",
    component: Ayuda,
    label: "Ayuda",
    public: false,
  },
  {
    path: "/envio",
    component: Shipment,
    label: "",
    public: false,
  },
];

export default pathRoutes;
